import React from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import commonUtils from "../../helpers/commonUtils";
import { useLanguageContext } from "../../Context/LanguageContext";
import TypeAhead from "../AddRole/TypeAhead";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import { useRef } from "react";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

import ReusableCard from "../ReusableComponent/ReusableCard";
import EnhancedTable from "../ReusableComponent/MuiTable";

const AddEquipmentToEquipmentGroup = (props) => {
  const { handleCompleted, equipmentGrpId } = props.data;
  const [searchedEquList, setSearchedEquList] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]);
  const [selectedEquId, setSelectedEquId] = useState(0);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [buttonStatus, setbuttonStatus] = useState(true);
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [bezeichnungDetails, setBezeichnungDetails] = useState("");
  const { localization } = useLanguageContext();
  const [itemList, setItemList] = useState([]);
  const [itemSelected, setItemSelected] = useState(0);

  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const equipmentId = useRef("");
  let equpAddedlist = useRef([]);
  const typeHeadRef = useRef("");

  const text = (
    <div className="row justify-content-center reusableCard pl-5 pr-5">
      <p>
        {localization.msg1 + " ? " + localization.msg2}{" "}
        <span className="reusableCardLink">
          <RenderAddEquipmentButton />
        </span>
        .
      </p>
    </div>
  );

  const searchEquipmetList = (inputString) => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getEquipment(inputString);
  };

  const getEquipmentsByEquGroupId = (equGrpId) => {
    EquipmentGroupActions.getEquipmentByEquGrpId(equGrpId);
    setGlobalSpinner(true);
  };

  useEffect(() => {
    if (equipmentGrpId) {
      equipmentId.current = equipmentGrpId;
      getEquipmentsByEquGroupId(equipmentGrpId);
    }
  }, [equipmentGrpId]);
  useEffect(() => {
    if (selectedEquId !== 0) {
      setbuttonStatus(false);
    } else {
      setbuttonStatus(true);
    }
  }, [selectedEquId]);

  useEffect(() => {
    let _tempList = [];
    equpAddedlist.current = equipmentList.map((items) => {
      _tempList.push({
        id: items.id,
        label: items.bezeichnung,
      });
      return items.id;
    });
    setItemList(_tempList);
  }, [equipmentList]);

  const addEquipmentToEquGroup = (e) => {
    e.preventDefault();
    var BezeichnungData = {
      BezeichnungID: selectedEquId,
      AnlagegruppeID: equipmentGrpId,
    };
    setGlobalSpinner(true);
    EquipmentGroupActions.AddAnlagegruppeBezeichnung(BezeichnungData);
  };

  useEffect(() => {
    function addEquipmentToEquGroupSuccess() {
      var res = equipmentGroupStore.getAddEquipmentToEquGrpResult();
      if (res) {
        getEquipmentsByEquGroupId(equipmentId.current);
        setSelectedEquId(0);
        toast.success(localization.equipmentAddedToEquipmentGroup);
      }
      typeHeadRef.current.resetTypeHead();
    }

    function addEquipmentToEquGroupFailure() {
      var res = equipmentGroupStore.getAddEquipmentToEquGrpResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_EQUIPMENT_TO_EQU_GROUP_SUCCESS,
      addEquipmentToEquGroupSuccess
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_EQUIPMENT_TO_EQU_GROUP_FAILURE,
      addEquipmentToEquGroupFailure
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_EQUIPMENT_TO_EQU_GROUP_SUCCESS,
        addEquipmentToEquGroupSuccess
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_EQUIPMENT_TO_EQU_GROUP_FAILURE,
        addEquipmentToEquGroupFailure
      );
    };
  }, []);

  useEffect(() => {
    function getEquipmentsByEquGroupIdSuccess() {
      var res = equipmentGroupStore.getEquipmentByEquGrpResult();
      if (res.length > 0) {
        setEquipmentList(res);
      } else {
        setEquipmentList([]);
      }
      handleCompleted("AddEquipment", res.length > 0);
      setGlobalSpinner(false);
    }

    function getEquipmentsByEquGroupIdFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_EQUIPMENT_BY_EQUGROUP_ID_SUCCESS,
      getEquipmentsByEquGroupIdSuccess
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_EQUIPMENT_BY_EQUGROUP_ID_FAILURE,
      getEquipmentsByEquGroupIdFailure
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_EQUIPMENT_BY_EQUGROUP_ID_SUCCESS,
        getEquipmentsByEquGroupIdSuccess
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_EQUIPMENT_BY_EQUGROUP_ID_FAILURE,
        getEquipmentsByEquGroupIdFailure
      );
    };
  }, []);

  useEffect(() => {
    function deleteEquipmentForEquGrpSuccess() {
      var res = equipmentGroupStore.getDeleteEquipmentForEquGrpResult();

      if (res.length > 0) {
        toast.error(
          " You can not delete this equipment name as it has associated equipment.\n" +
            res.join(",")
        );
      } else {
        toast.success(localization.equipmentDeletedSuccessfully);
      }
      getEquipmentsByEquGroupId(equipmentId.current);
    }

    function deleteEquipmentForEquGrpFailure() {
      var res = equipmentGroupStore.getDeleteEquipmentForEquGrpResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_EQUIPMENT_FOR_EQUGROUP_SUCCESS,
      deleteEquipmentForEquGrpSuccess
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_EQUIPMENT_FOR_EQUGROUP_FAILURE,
      deleteEquipmentForEquGrpFailure
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_EQUIPMENT_FOR_EQUGROUP_SUCCESS,
        deleteEquipmentForEquGrpSuccess
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_EQUIPMENT_FOR_EQUGROUP_FAILURE,
        deleteEquipmentForEquGrpFailure
      );
    };
  }, []);

  useEffect(() => {
    function searchEquipmetListSuccess() {
      var res = equipmentGroupStore.getEquipment();
      let equList = [];
      if (res.length > 0) {
        res.map((key, index) => {
          equList.push({ id: key.id, label: key.bezeichnung });
        });
        const tempList = equList.filter((items) => {
          return equpAddedlist.current.every((element) => {
            return element != items.id;
          });
        });
        setSearchedEquList(tempList);
      } else {
        setSearchedEquList([]);
      }
      setGlobalSpinner(false);
    }

    function searchEquipmetListFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_EQUIPMENT_SUCCESS,
      searchEquipmetListSuccess
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_EQUIPMENT_FAILURE,
      searchEquipmetListFailure
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_EQUIPMENT_SUCCESS,
        searchEquipmetListSuccess
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_EQUIPMENT_FAILURE,
        searchEquipmetListFailure
      );
    };
  }, [searchedEquList]);

  useEffect(() => {
    function addorUpdateEquipmentSuccess() {
      var res = equipmentGroupStore.getAddorUpdateEquipmentResult();
      commonUtils.hideModalPopUp("addBezeichnungModalClose");
      toast.success(localization.equipmentAddedSuccessfully);
      EquipmentGroupActions.AddAnlagegruppeBezeichnung({
        BezeichnungID: res.id,
        AnlagegruppeID: equipmentId.current,
      });
    }

    function addorUpdateEquipmentFailure() {
      var res = equipmentGroupStore.getAddorUpdateEquipmentResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_SUCCESS,
      addorUpdateEquipmentSuccess
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_FAILURE,
      addorUpdateEquipmentFailure
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_SUCCESS,
        addorUpdateEquipmentSuccess
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_FAILURE,
        addorUpdateEquipmentFailure
      );
    };
  }, []);

  const typeAheadInputChangeCallback = (text) => {
    if (text !== "") {
      searchEquipmetList(text);
    } else {
      setSelectedEquId(0);
    }
  };

  const typeAheadSelectedCallback = (selectedList) => {
    if (selectedList && selectedList.length > 0) {
      setSelectedEquId(selectedList[0].id);
    }
  };

  function handleSelectedItem() {
    setSelectedEquId(0);
  }

  function handleDeleteButton() {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(
      localization.deleteWithout +
        " " +
        itemSelected.length +
        " " +
        localization.equipment +
        " ?"
    );
    setCallbackData({
      equGrpId: equipmentGrpId,
      equipmentId: itemSelected,
    });
    setEventType("DELETE_EQUIPMENT_FOR_EQU_GRP");
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_EQUIPMENT_FOR_EQU_GRP":
          setGlobalSpinner(true);
          EquipmentGroupActions.deleteEquipmentForEquGroup(
            data.equGrpId,
            data.equipmentId
          );
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  function RenderAddEquipmentButton(props) {
    return (
      <>
        <span
          className="cursorPoint"
          id=""
          size={20}
          onClick={() => {
            setBezeichnungDetails("");
          }}
          data-toggle="modal"
          data-target="#addBezeichnung"
        >
          {localization.here}
        </span>
      </>
    );
  }

  return (
    <>
      <div
        className="
        row ml-0 mr-0 containerStyle"
      ></div>

      <div className="row d-flex justify-content-center">
        <ReusableCard
          title=""
          func={addEquipmentToEquGroup}
          buttonStatus={buttonStatus}
          buttonname={localization.save}
          text={text}
        >
          <TypeAhead
            ref={typeHeadRef}
            typeAheadInputChangeCallback={typeAheadInputChangeCallback}
            typeAheadSelectedCallback={typeAheadSelectedCallback}
            isMultiple={false}
            searchedList={searchedEquList}
            resetSelectedItem={handleSelectedItem}
          />
        </ReusableCard>
      </div>

      <EnhancedTable
        tableHeaders={[localization.name]}
        ItemList={itemList}
        title={localization.equipmentList}
        columnName={localization.equipment}
        setItemSelected={setItemSelected}
        deletdHandle={handleDeleteButton}
      />

      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default AddEquipmentToEquipmentGroup;
